@if (finishedLoading) {
    <div>
        @if (detailsModel.guid) {
            <div class="detail-page-summary">
                <div class="row">
                    <div class="col-lg-6 left-block">
                        <div class="property"><b>{{ "detailMain.summaryId" | t }}</b> {{ detailsModel.identifier }}</div>
                        <div class="property text-truncate">
                            <b>{{ "detailMain.summaryName" | t }}</b>&nbsp;<span data-uiid="finding-report-name-label">{{
                                detailsModel.name
                            }}</span>
                        </div>
                        <div class="property">
                            <b>{{ "detailMain.summaryResponsible" | t }}</b> {{ detailsModel.responsibleName }}
                        </div>
                    </div>
                    <div class="col-lg-6 right-block">
                        <div class="property">
                            <b>{{ "detailMain.summaryDueDate" | t }}</b> {{ detailsModel.reportDueDate | dateFormat }}
                        </div>
                        <div class="property">
                            <b>{{ "detailMain.summaryDateCreated" | t }}</b> {{ detailsModel.createdAt | dateFormat }}
                        </div>
                        <div class="property">
                            <b>{{ "detailMain.summaryOverallScore" | t }}</b>
                            <div
                                class="summary-score-color"
                                [style.background-color]="
                                    detailsModel.overallScoreColor
                                        ? detailsModel.overallScoreColor
                                        : ''
                                "
                            ></div>
                            {{ detailsModel.overallScoreName }}
                        </div>
                    </div>
                </div>
            </div>
        }
        <div class="detail-page-card mt-3" [formGroup]="formGroup">
            <div class="detail-page-card-title">
                {{ "detailMain.detailsTitle" | t }}
            </div>
            <div class="detail-page-card-body padded form-group-styling">
                <div class="row">
                    <div class="col-xl-6 left-block">
                        @if (detailsModel.auditGuid) {
                            <div class="row">
                                <div class="form-group">
                                    <label class="form-label">{{
                                        "detailMain.audit" | t
                                    }}</label>
                                    <div class="input-group">
                                        <input
                                            type="text"
                                            value="{{ detailsModel.auditDisplayName }}"
                                            class="form-control form-control-sm"
                                            readonly
                                        />
                                        @if (canOpenAudit) {
                                            <label
                                                class="input-group-text action-button"
                                                (click)="openAudit()"
                                            >
                                                <i class="fas fa-external-link-alt"></i>
                                            </label>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <cerrix-textfield
                                        [fieldLabel]="'detailMain.reportName' | t"
                                        dataUiid="finding-report-name"
                                        formControlName="name"
                                        [placeholder]="'detailMain.requiredPlaceholder' | t"
                                    ></cerrix-textfield>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>{{ "detailMain.reportType" | t }}</label>
                                    <ng-select
                                        data-uiid="finding-report-type"
                                        [items]="reportTypesPromise | async"
                                        formControlName="reportTypeId"
                                        bindValue="value"
                                        [placeholder]="'detailMain.requiredPlaceholder' | t"
                                        [loading]="reportTypesLoading"
                                        (change)="onReportTypeChange($event)"
                                    >
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <div class="form-group-separator"></div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <cerrix-textfield
                                        [fieldLabel]="'detailMain.reportNo' | t"
                                        dataUiid="finding-report-no"
                                        formControlName="reportNumber"
                                    ></cerrix-textfield>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <cerrix-textfield
                                        [fieldLabel]="'detailMain.subName' | t"
                                        dataUiid="finding-report-subname"
                                        formControlName="subName"
                                    ></cerrix-textfield>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>{{ "detailMain.reportUrl" | t }}</label>
                                    <cerrix-url-input
                                        dataUiid="finding-report-url"
                                        formControlName="reportUrl"
                                    ></cerrix-url-input>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>{{ "detailMain.overallScore" | t }}</label>
                                    <ng-select
                                        data-uiid="finding-report-overallscore"
                                        [items]="overallScoresPromise | async"
                                        formControlName="overallScoreId"
                                        bindValue="value"
                                        [loading]="reportTypesLoading"
                                    >
                                        <ng-template ng-label-tmp ng-option-tmp let-item="item">
                                            <span
                                                class="select-template-color"
                                                [style.background-color]="item.color"
                                            ></span>
                                            {{ item.label }}
                                        </ng-template>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>{{ "detailMain.validationType" | t }}</label>
                                    <ng-select
                                        data-uiid="finding-report-validationtype"
                                        [items]="validationTypesPromise | async"
                                        formControlName="validationTypeId"
                                        bindValue="value"
                                        [loading]="validationTypesLoading"
                                    >
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>{{ "detailMain.reportDate" | t }}</label>
                                    <date-input
                                        data-uiid="finding-report-date"
                                        formControlName="reportDate"
                                    ></date-input>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <label>{{ "detailMain.reportDueDate" | t }}</label>
                                    <date-input
                                        data-uiid="finding-report-duedate"
                                        formControlName="reportDueDate"
                                    ></date-input>
                                </div>
                            </div>
                        </div>
                        <div class="form-group-separator"></div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label>{{
                                        "detailMain.organizationResponsible" | t
                                    }}</label>
                                    <cerrix-select-tree
                                        data-uiid="finding-report-responsibleorganization"
                                        [tree]="responsibleOrganizations"
                                        formControlName="responsibleOrganizationId"
                                        [placeholder]="'detailMain.requiredPlaceholder' | t"
                                        [multiselect]="false"
                                    >
                                    </cerrix-select-tree>
                                </div>
                                <div class="form-group">
                                    <label>{{ "detailMain.responsible" | t }}</label>
                                    <ng-select
                                        data-uiid="finding-report-responsible"
                                        [items]="responsiblesPromise | async"
                                        formControlName="responsibleId"
                                        bindValue="value"
                                        [placeholder]="'detailMain.requiredPlaceholder' | t"
                                        [loading]="responsiblesLoading"
                                    >
                                    </ng-select>
                                </div>
                                <div class="form-group">
                                    <label>{{
                                        "detailMain.organizationReviewer" | t
                                    }}</label>
                                    <cerrix-select-tree
                                        data-uiid="finding-report-reviewerorganization"
                                        [tree]="reviewerOrganizations"
                                        formControlName="reviewerOrganizationId"
                                        [multiselect]="false"
                                    >
                                    </cerrix-select-tree>
                                </div>
                                <div class="form-group">
                                    <label>{{ "detailMain.reviewer" | t }}</label>
                                    <ng-select
                                        [items]="reviewersPromise | async"
                                        data-uiid="finding-report-reviewer"
                                        formControlName="reviewerId"
                                        bindValue="value"
                                        [placeholder]="'detailMain.requiredPlaceholder' | t"
                                        [loading]="reviewersLoading"
                                    >
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 right-block">
                        <div class="form-group-separator d-xl-none"></div>
                        <div class="row">
                            <div class="form-group col">
                                <cerrix-textarea
                                    [fieldLabel]="'detailMain.scopeAndObjective' | t"
                                    dataUiid="finding-report-scopeobjective"
                                    formControlName="scopeAndObjective"
                                ></cerrix-textarea>
                            </div>
                        </div>
                        <div class="form-group-separator"></div>
                        <div class="row">
                            <div class="form-group col">
                                <cerrix-textarea
                                    [fieldLabel]="'detailMain.conclusion' | t"
                                    dataUiid="finding-report-conclusion"
                                    formControlName="conclusion"
                                ></cerrix-textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        @if (detailsModel.guid) {
            <linked-moi-overview
                [moiType]="moiType"
                [parentGuid]="detailsModel.guid"
                [canAdd]="permissionsModel.canAddMoi"
                [canDelete]="permissionsModel.canDeleteMoi"
                [useLazyLoading]="false"
            >
            </linked-moi-overview>
        }
    </div>
} @else {
    <div>
        <div class="fancy-loader"></div>
    </div>
}
